import React from "react";
import rough from "roughjs";
import type { Drawable, Options } from "roughjs/bin/core";

/**
 * Seeded Rough.js → SVG. A single module-level generator; every shape passes a
 * stable `seed` so the hand-drawn jitter is DETERMINISTIC (no per-frame "boiling"
 * and live-preview === export). Animate via parent <g transform>, not by changing
 * shape geometry, to keep seeds stable.
 */
const gen = rough.generator();

export function roughEls(drawable: Drawable): React.ReactNode {
  return gen.toPaths(drawable).map((p, i) => (
    <path key={i} d={p.d} stroke={p.stroke} strokeWidth={p.strokeWidth} fill={p.fill ?? "none"} strokeLinecap="round" strokeLinejoin="round" />
  ));
}

export const rg = {
  rectangle: (x: number, y: number, w: number, h: number, o: Options) => gen.rectangle(x, y, w, h, o),
  ellipse: (cx: number, cy: number, w: number, h: number, o: Options) => gen.ellipse(cx, cy, w, h, o),
  circle: (cx: number, cy: number, d: number, o: Options) => gen.circle(cx, cy, d, o),
  line: (x1: number, y1: number, x2: number, y2: number, o: Options) => gen.line(x1, y1, x2, y2, o),
  polygon: (pts: Array<[number, number]>, o: Options) => gen.polygon(pts, o),
  path: (d: string, o: Options) => gen.path(d, o),
};
